import { render, staticRenderFns } from "./FreeGiftPage.vue?vue&type=template&id=1ead8288&"
import script from "./FreeGiftPage.vue?vue&type=script&lang=ts&"
export * from "./FreeGiftPage.vue?vue&type=script&lang=ts&"
import style0 from "./FreeGiftPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports